import { Model } from "pinia-orm";
import Supervision from "./Supervision";

export default class SupervisionHistory extends Model {
  static entity = "supervision_history";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      supervisionUuid: this.string(""),
      type: this.string(""),
      startedAt: this.attr(null),
      endedAt: this.attr(null),
      reviewerUuid: this.string(""),
      reviewerRole: this.string(""),
      decisionStatus: this.string(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      supervision: this.belongsTo(Supervision, "supervisionUuid"),
    };
  }
}
